import React from 'react';
import '../../assets/css/layouts/Dashboard.css';

function Dashboard() {
  return (
    <div className="dashboard-container min-vh-100">
      {/* Header */}
      <div className="dashboard-header">
        <h2 className="dashboard-title">Analytics</h2>
      </div>

      {/* Cards */}
      <div className="row g-4">
        <div className="col-md-4 col-sm-6 col-12">
          <div className="card custom-card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Total Products</h5>
              <p className="card-text fs-4">150</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-sm-6 col-12">
          <div className="card custom-card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Active Orders</h5>
              <p className="card-text fs-4">34</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-sm-6 col-12">
          <div className="card custom-card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Pending Requests</h5>
              <p className="card-text fs-4">12</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
